import React from 'react'
import PropTypes from 'prop-types'

class PopContent extends React.Component {
  render() {
    const { content } = this.props
    return (
      <div
        style={{
          ...this.props.style,
          position: 'absolute',
          backgroundColor: '#EEE',
          boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
          border: '1px solid #CCC',
          borderRadius: 3,
          marginLeft: -5,
          marginTop: 5,
          padding: 10
        }}
      >
        <strong>{content}</strong>
      </div>
    )
  }
}

PopContent.propTypes = {
  content: PropTypes.string
}

PopContent.defaultProps = {
  content: 'Hey! What to show?'
}

export default PopContent



// WEBPACK FOOTER //
// ./src/components/widgets/PopContent.js